import React, { useState, useEffect } from "react";
import { getBookingsByUser } from "../Common/apis";
import Loader from "../Loader/Loader.jsx";
import Aos from "aos";

const OrderHistory = () => {
  useEffect(() => {
      Aos.init({
        duration: 1000, // animation duration in ms
        once: true,     // animate only once
      });
    }, []);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await getBookingsByUser();
      setOrders(response?.data || []);
    } catch (error) {
      console.error("Error fetching order history:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="profile-info">
      <div className="profile-info-heading overflow-hidden">
        <h3 className="pb-[20px]" data-aos="fade-right">Order History</h3>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <table className="table m-0 table-striped">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Order ID</th>
              <th scope="col">Address</th>
              <th scope="col">Total Amount</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.length > 0 ? (
              orders.map((order, index) => (
                <tr key={order._id}>
                  <th scope="row">{index + 1}</th>
                  <td>{order._id}</td>
                  <td>
                    {order?.address?.name +
                      " " +
                      order?.address?.fullAddress +
                      " " +
                      order?.address?.landmark +
                      " " +
                      order?.address?.mobile}
                  </td>
                  <td>${order?.payment?.amount}</td>
                  <td>{order.status}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No orders found.</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      {/* <table className="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">First</th>
            <th scope="col">Last</th>
            <th scope="col">Handle</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">1</th>
            <td>Mark</td>
            <td>Otto</td>
            <td>@mdo</td>
          </tr>
          <tr>
            <th scope="row">2</th>
            <td>Jacob</td>
            <td>Thornton</td>
            <td>@fat</td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td colspan="2">Larry the Bird</td>
            <td>@twitter</td>
          </tr>
        </tbody>
      </table> */}
    </div>
  );
};

export default OrderHistory;
